import suitupLogo from '../assets/suitup-logo.png';

const ORANGE = '#E8981E';

const Sparkle = ({ className, size = 16 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 2c.6 4.8 2.6 6.8 7.4 7.4C14.6 10 12.6 12 12 16.8 11.4 12 9.4 10 4.6 9.4 9.4 8.8 11.4 6.8 12 2Z"
      fill={ORANGE}
      fillOpacity="0.5"
    />
  </svg>
);

/**
 * Shared shell for the login / register screens.
 * Cream gradient background, gold sparkles, centered logo + tagline, title.
 */
const AuthLayout = ({ title, altText, altLinkText, altLinkTo, LinkComponent, children }) => {
  const AltLink = LinkComponent;
  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-b from-[#faf6ee] via-[#f7f1e6] to-[#f3ead9]">
      <Sparkle className="absolute top-8 right-6" size={28} />
      <Sparkle className="absolute top-14 left-8" size={34} />
      <Sparkle className="absolute top-24 right-16" size={20} />
      <Sparkle className="absolute top-36 left-4" size={24} />
      <Sparkle className="absolute top-1/4 right-4" size={30} />
      <Sparkle className="absolute top-1/3 left-14" size={18} />
      <Sparkle className="absolute top-1/3 right-20" size={22} />
      <Sparkle className="absolute top-1/2 left-6" size={30} />
      <Sparkle className="absolute top-1/2 right-8" size={20} />
      <Sparkle className="absolute top-2/3 right-6" size={26} />
      <Sparkle className="absolute top-2/3 left-12" size={22} />
      <Sparkle className="absolute bottom-40 left-10" size={28} />
      <Sparkle className="absolute bottom-36 right-6" size={30} />
      <Sparkle className="absolute bottom-24 left-16" size={20} />
      <Sparkle className="absolute bottom-20 right-14" size={26} />
      <Sparkle className="absolute bottom-10 left-6" size={24} />
      <Sparkle className="absolute bottom-8 right-10" size={30} />

      <div className="relative mx-auto flex min-h-screen w-full max-w-md flex-col justify-center px-6 py-5">
        <div className="text-center">
          <img src={suitupLogo} alt="suitUp" className="mx-auto h-16 w-auto sm:h-20" />
          <div className="mt-2 flex items-center justify-center gap-2">
            <span className="h-px w-6" style={{ background: ORANGE }} />
            <span className="text-sm font-bold sm:text-base" style={{ color: ORANGE }}>גיוס עורכי דין ויועצים משפטיים</span>
            <span className="h-px w-6" style={{ background: ORANGE }} />
          </div>

          <h1 className="mt-4 text-2xl font-extrabold text-gray-900">{title}</h1>

          {altLinkText && (
            <p className="mt-2 text-sm text-gray-600">
              {altText}{' '}
              <AltLink to={altLinkTo} className="font-semibold text-blue-600 hover:text-blue-500">
                {altLinkText}
              </AltLink>
            </p>
          )}
        </div>

        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
